import React from "react";
import { createUploadLink } from "apollo-upload-client";
import gql from "graphql-tag";
import config from "./config";

import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import { ApolloLink } from "apollo-link";

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) graphQLErrors.map(({ message, locations, path }) => console.log(`[GraphQL error]: Message: ${message}`, { locations, path }));
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    createUploadLink({
      uri: config.graphql_uri,
      credentials: "include"
    })
  ]),
  cache: new InMemoryCache()
});

export const serverStackClient = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) graphQLErrors.map(({ message, locations, path }) => console.log(`[GraphQL error]: Message: ${message}`, { locations, path }));
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    createUploadLink({
      uri: config.server_stack_url,
      credentials: "include"
    })
  ]),
  cache: new InMemoryCache()
});

export const AppContext = React.createContext();
export const QUERY_MASTER_DATA = gql`
  {
    masterdata
  }
`;
export const QUERY_ME = gql`
  {
    me {
      _id
      roles
      name
      email
      phone
      address
      facebook
      google
      twitter
      zendeskId
      image {
        original
        filename
        mime
        checksum
        cdnUri
      }
      gender
      companies {
        _id
        name
        plan
        inContract
        status
        canEditFreight
      }
    }
  }
`;

export const MUTATION_LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      _id
      roles
      name
      email
      phone
      address
      facebook
      google
      twitter
      zendeskId
      image {
        original
        filename
        mime
        checksum
        cdnUri
      }
      gender
      companies {
        _id
        name
        plan
        inContract
        status
      }
    }
  }
`;

export const MUTATION_LOGOUT = gql`
  mutation Logout {
    logout
  }
`;

export const QUERY_MAKES = gql`
  query makes($params: Object) {
    makes(params: $params) {
      _id
      name
      key
      carCount
    }
  }
`;

export const QUERY_MODELS = gql`
  query models($filters: Object, $offset: Int, $limit: Int, $sort: String, $order: String) {
    models(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      models {
        _id
        name
        key
        makeModelKey
        make
        locked
        alias {
          _id
          name
          key
          makeModelKey
        }
        carCount
      }
      total
    }
  }
`;

export const QUERY_HAS_NEW_DOC = gql`
  {
    hasNewDoc
  }
`;

export const withContext = Component => props => <AppContext.Consumer>{context => <Component {...props} {...context} />}</AppContext.Consumer>;
